import { Checkbox } from "@/components/ui/checkbox";
import { memo } from "react";
import { useRowSelectionCell } from "../hooks/useRowSelectionCell";

interface SelectRowCellProps {
  id: string;
  disabled?: boolean;
}

const SelectRowCellComponent = ({ id, disabled }: SelectRowCellProps) => {
  const { isSelected, toggle } = useRowSelectionCell(id);

  return (
    <div className="flex w-fit h-full items-center justify-center p-0 mx-auto">
      <Checkbox
        checked={isSelected}
        onCheckedChange={toggle}
        disabled={disabled}
      />
    </div>
  );
};

export const SelectRowCell = memo(SelectRowCellComponent);
